import React, { useCallback } from 'react'
import { TtTrayImage } from '@23/react'
import {
  useOverlayState,
  removeOverlay,
  setChyron,
} from '../../../../firebase/hooks/useOverlays'
import { usePanelScreen } from '../../../../firebase/hooks/usePanel'
import { useLocalParticipant } from '../../../../webrtc/webRTCRoom'
// @ts-expect-error — importing js
import usePlaybackIntent from '../../../hooks/usePlaybackIntent'
import { ChyronType } from '../../../../firebase/model/chyron-model'
import {
  switchToTray,
  useFloorState,
} from '../../../../firebase/hooks/useFloor'
import {
  setActiveCard,
  useTrayCard,
  useTrayCardState,
} from '../../../../firebase/hooks/useTray'
import { type PropsWithTrayItemChildren } from '../TrayItem'

interface ImageCardProps {
  id: string
}

const ImageCard = ({
  id,
  children,
}: PropsWithTrayItemChildren<ImageCardProps>) => {
  const card = useTrayCard(id)
  const cardState = useTrayCardState(id)
  const overlay = useOverlayState()
  const floor = useFloorState()
  const panelScreen = usePanelScreen()
  const { setPlaybackPauseIntent } = usePlaybackIntent()
  const localParticipant = useLocalParticipant()

  const clearSpeakerChyron = useCallback(() => {
    if (overlay?.type === ChyronType.Speaker) {
      setChyron(null)
    }
  }, [overlay?.type])

  const onCardClickHandler = useCallback(() => {
    if (card?.type === 'image' && card.thumbnail) {
      setActiveCard(id)
      setPlaybackPauseIntent()

      if (overlay?.type === ChyronType.Speaker) {
        removeOverlay()
      }

      const isMixingPanelWithTray =
        floor?.layout === 'panel' && panelScreen === 'tray'

      if (!isMixingPanelWithTray) {
        switchToTray()
      }

      clearSpeakerChyron()
    }
  }, [
    card,
    id,
    setPlaybackPauseIntent,
    overlay?.type,
    floor?.layout,
    panelScreen,
    clearSpeakerChyron,
  ])

  if (card?.type !== 'image') return null

  // image is midst being uploaded by other participant
  if (card.participantId && +card.participantId !== localParticipant?.id) {
    return null
  }

  return (
    <TtTrayImage
      src={card.thumbnail}
      label={card.label}
      selected={cardState === 'active'}
      disabled={cardState === 'done'}
      onTt-click={(event) => {
        if (event.target === event.currentTarget) {
          onCardClickHandler()
        }
      }}
    >
      {children?.({ isMedia: true })}
    </TtTrayImage>
  )
}

export default ImageCard
